const keyMirror = require("keymirror");

export const CommonConstants = keyMirror({
  FETCH_STATES: undefined,
  FETCH_PRODUCTS: undefined,
  FETCH_TIMEZONES: undefined
});
